// This navbar2 is for the example of react context
import { useEffect, useState } from "react";
import { ActiveAnchorProvider } from "../../../context/active-anchor-context/ActiveAnchorContext";
import { Nav, Navbar } from "react-bootstrap";
import CartButton from "../../CartButton";
import CartModal from "../../CartModal";
import AnchorLink2 from "../anchor-link2/AnchorLink2";
import "./Navbar2.scss";

const ids = ["about", "products", "nutrition-facts", "maca-dishes", "contact"];

export default function Navbar2() {
  const [scrollY, setScrollY] = useState(0);
  const [isCartVisible, setIsCartVisible] = useState(false);
  const offset = 56;

  useEffect(() => {
    const onScroll = () => setScrollY(window.pageYOffset || 0);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Navbar
      expand="lg"
      sticky="top"
      variant="dark"
      className={scrollY ? "" : "scroll-top"}
    >
      <Navbar.Brand
        href="/"
        onClick={(e) => {
          e.preventDefault();
          scrollToTop();
        }}
      >
        MACCA VAN PHUC
      </Navbar.Brand>
      <Nav.Item>
        <CartButton onClick={() => setIsCartVisible(true)} />
        <CartModal
          isOpen={isCartVisible}
          onHide={() => setIsCartVisible(false)}
        />
      </Nav.Item>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <ActiveAnchorProvider ids={ids} offset={offset}>
          <Nav className="ml-auto nav-items">
            <AnchorLink2 href="#about">Giới Thiệu</AnchorLink2>
            <AnchorLink2 href="#products">Sản Phẩm</AnchorLink2>
            <AnchorLink2 href="#nutrition-facts">
              Giá Trị Dinh Dưỡng
            </AnchorLink2>
            <AnchorLink2 href="#maca-dishes">Món Ngon Với Maca</AnchorLink2>
            <AnchorLink2 href="#contact">Liên Hệ</AnchorLink2>
          </Nav>
        </ActiveAnchorProvider>
      </Navbar.Collapse>
    </Navbar>
  );
}
